import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';


const routes: Routes = [
    {
        path: '', redirectTo: 'login', pathMatch: 'full'
    },

    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then((m) => m.LoginModule)
    },

    {
        path: 'logistic',
        loadChildren: () => import('./logistic/logistic.module').then((m) => m.LogisticModule)
    }
];

@NgModule({
    // 'computed': a browser back or forward a guard rejects is undone by moving the browser back to the page's
    // own entry. The default, 'replace', would write the page's URL over the entry the browser went to, losing
    // that previous page from the history. AppHistoryService relies on this (see its restore()).
    imports: [RouterModule.forRoot(routes, {canceledNavigationResolution: 'computed'})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
